import { config } from '~app/config';

import { lastConfirmedPhoneNumberAtom } from '@breezeventures/web-ph-client-auth/model';
import { useAtomValue } from 'jotai';

export const useUserPhone = () => {
  const lastConfirmedPhoneNumber = useAtomValue(lastConfirmedPhoneNumberAtom);

  if (lastConfirmedPhoneNumber) {
    return lastConfirmedPhoneNumber;
  }

  if (config.isMockingEnabled) {
    return '+639999999999';
  }

  return null;
};
